export const PATH = {
    WELCOME_WITHOUT_ID: '/welcome',
    WELCOME: '/welcome/:uid',
    THANK_YOU: '/thankyou',
    SORRY: '/sorry',
    DONATE: '/donate',
    WALL: '/wall/:uid',
    REQUEST: '/request/:id',
}
